import { useMemo } from "react";
import { format, startOfMonth, endOfMonth, startOfWeek, endOfWeek, eachDayOfInterval, isSameMonth, isSameDay, parseISO } from "date-fns";
import { TYPE_COLOR } from "./constants";

const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const sameDay = (e, day) => { try { return isSameDay(parseISO(e.date), day); } catch { return false; } };

function DayCell({ day, cursor, events, editor, onDayClick, onEventClick }) {
  const inMonth = isSameMonth(day, cursor);
  const today = isSameDay(day, new Date());
  return (
    <div onClick={() => onDayClick(day)}
      className={`border-r border-b border-border min-h-[104px] p-1.5 align-top transition-colors ${inMonth ? "bg-card" : "bg-muted/30"} ${editor ? "cursor-pointer hover:bg-accent/40" : ""}`}>
      <div className={`text-xs font-semibold mb-1 h-6 w-6 grid place-items-center rounded-full ${today ? "bg-primary text-primary-foreground" : inMonth ? "text-foreground" : "text-muted-foreground/50"}`}>{format(day, "d")}</div>
      <div className="space-y-1">
        {events.slice(0, 3).map((e) => (
          <button key={e.id} data-testid="calendar-event" onClick={(ev) => { ev.stopPropagation(); onEventClick(e); }}
            className={`w-full text-left text-[11px] leading-tight px-1.5 py-0.5 rounded-sm truncate ${TYPE_COLOR[e.type] || "bg-muted"}`}>
            {e.time ? `${e.time} · ` : ""}{e.title}
          </button>
        ))}
        {events.length > 3 && <div className="text-[10px] text-muted-foreground pl-1">+{events.length - 3} more</div>}
      </div>
    </div>
  );
}

export function CalendarGrid({ cursor, events, editor, onDayClick, onEventClick }) {
  const days = useMemo(() => eachDayOfInterval({ start: startOfWeek(startOfMonth(cursor)), end: endOfWeek(endOfMonth(cursor)) }), [cursor]);
  return (
    <div className="grid grid-cols-7 border-t border-l border-border" data-testid="calendar-grid">
      {WEEKDAYS.map((d) => (
        <div key={d} className="border-r border-b border-border bg-secondary/60 py-2 text-center text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">{d}</div>
      ))}
      {days.map((day) => (
        <DayCell key={day.toISOString()} day={day} cursor={cursor} events={events.filter((e) => sameDay(e, day))} editor={editor} onDayClick={onDayClick} onEventClick={onEventClick} />
      ))}
    </div>
  );
}
